import styled from 'styled-components';
import { IconBellAlert } from '@shared/ui/icons';
import { useListAnnouncementsQuery } from '@shared/api';

interface Props {
  /** Открыть модалку «Что нового». Состояние держит AppShell — его же
   *  использует живая плашка (UpdatesBanner). */
  onOpen: () => void;
}

const Trigger = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition:
    color ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.easeOut},
    background ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.easeOut},
    border-color ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.easeOut};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.surfaceHover};
    border-color: ${({ theme }) => theme.colors.borderStrong};
  }
`;

const Count = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ theme }) => theme.colors.primary};
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  box-shadow: ${({ theme }) => theme.shadow.sm};
`;

export function UpdatesBell({ onOpen }: Props) {
  const { data: announcements = [] } = useListAnnouncementsQuery();
  const unread = announcements.reduce((n, a) => (a.read_at == null ? n + 1 : n), 0);

  return (
    <Trigger
      type="button"
      onClick={onOpen}
      title="Что нового"
      aria-label={unread > 0 ? `Что нового — непрочитанных: ${unread}` : 'Что нового'}
    >
      <IconBellAlert size={18} />
      {unread > 0 && <Count aria-hidden="true">{unread > 99 ? '99+' : unread}</Count>}
    </Trigger>
  );
}
